export default {
    namespaced: true,
    state: {
        tableData: [],
        agentTableData: [],
        logTableData: [],
    },
    mutations: {
        changeTableData(state, payload) {
            state.tableData = payload
        },
        removeOne(state, index) {
            state.tableData.splice(index, 1)
        },
        changeAgentTableData(state, payload) {
            state.agentTableData = payload
        },
        removeAgentOne(state, index) {
            state.agentTableData.splice(index, 1)
        },
        changeLogTableData(state, payload) {
            state.logTableData = payload
        },
        removeLogOne(state, index) {
            state.logTableData.splice(index, 1)
        },
    }
}